"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICEBERGER_NOT_OPTED_IN_PORTAL_SETTING = exports.RECIPIENT_PROPS = exports.RECIPIENTS_FATIGUE_SUPPRESSION_REASONS = exports.BLOG_EMAIL_TYPES = exports.RSS_STATUS_ALERT_TYPE = exports.WARNING_RSS_STATUS_TYPES = exports.VALID_RSS_STATUS_TYPES = exports.RSS_STATUS_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _RSS_STATUS_ALERT_TYP;

var RSS_STATUS_TYPES = (0, _keyMirror.default)({
  FOUND_RSS_FEEDS: null,
  NO_FEEDS_FOUND: null,
  TIMEOUT: null,
  INVALID_URL: null,
  VALIDATOR_ERROR: null,
  HTTP_RETRIEVAL_ERROR: null,
  NO_GUID_OR_LINK: null,
  NO_GENERATED_GUID: null,
  FEED_EMPTY: null,
  FEED_OK: null
});
exports.RSS_STATUS_TYPES = RSS_STATUS_TYPES;
var VALID_RSS_STATUS_TYPES = [RSS_STATUS_TYPES.NO_GUID_OR_LINK, RSS_STATUS_TYPES.FEED_EMPTY, RSS_STATUS_TYPES.FEED_OK, RSS_STATUS_TYPES.FOUND_RSS_FEEDS];
exports.VALID_RSS_STATUS_TYPES = VALID_RSS_STATUS_TYPES;
var WARNING_RSS_STATUS_TYPES = [RSS_STATUS_TYPES.NO_GUID_OR_LINK, RSS_STATUS_TYPES.FEED_EMPTY];
exports.WARNING_RSS_STATUS_TYPES = WARNING_RSS_STATUS_TYPES;
var RSS_STATUS_ALERT_TYPE = (_RSS_STATUS_ALERT_TYP = {}, (0, _defineProperty2.default)(_RSS_STATUS_ALERT_TYP, RSS_STATUS_TYPES.NO_GUID_OR_LINK, 'warning'), (0, _defineProperty2.default)(_RSS_STATUS_ALERT_TYP, RSS_STATUS_TYPES.NO_GENERATED_GUID, 'warning'), (0, _defineProperty2.default)(_RSS_STATUS_ALERT_TYP, RSS_STATUS_TYPES.FEED_EMPTY, 'info'), _RSS_STATUS_ALERT_TYP);
exports.RSS_STATUS_ALERT_TYPE = RSS_STATUS_ALERT_TYPE;
var BLOG_EMAIL_TYPES = ['instant', 'daily', 'weekly', 'monthly'];
exports.BLOG_EMAIL_TYPES = BLOG_EMAIL_TYPES;
var RECIPIENTS_FATIGUE_SUPPRESSION_REASONS = (0, _keyMirror.default)({
  UNAVAILABLE: null,
  SETTING_NOT_ENABLED: null,
  UPDATE_IN_PROGRESS: null,
  PRESENT: null
});
exports.RECIPIENTS_FATIGUE_SUPPRESSION_REASONS = RECIPIENTS_FATIGUE_SUPPRESSION_REASONS;
var RECIPIENT_PROPS = ['vidsIncluded', 'vidsExcluded', 'mailingListsIncluded', 'mailingListsExcluded'];
exports.RECIPIENT_PROPS = RECIPIENT_PROPS;
var ICEBERGER_NOT_OPTED_IN_PORTAL_SETTING = 'Email:NotOptedInForIceberger';
exports.ICEBERGER_NOT_OPTED_IN_PORTAL_SETTING = ICEBERGER_NOT_OPTED_IN_PORTAL_SETTING;